import { databases } from "@/lib/appwrite";

export async function updateWorkSessionEnd(sessionId: string, clockOut: Date, location: [number, number]) {
  const [lat, lng] = location;
  
  try {
    const session = await databases.getDocument(
      import.meta.env.VITE_APPWRITE_DATABASE_ID,
      import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID,
      sessionId
    );

    // Calculo totalwork
    const clockInDate = new Date(session.clockIn);
    const totalWorkTimeHours = (clockOut.getTime() - clockInDate.getTime()) / (1000 * 60 * 60);

    // Actualiza los datos de la coleccion
    return await databases.updateDocument(
      import.meta.env.VITE_APPWRITE_DATABASE_ID,
      import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID,
      sessionId,
      {
        clockOut: clockOut.toISOString(),
        clockOutLocation: [String(lat), String(lng)],
        status: "inactive",
        totalWorkTime: totalWorkTimeHours, // Tiempo en horas
        updatedAt: clockOut.toISOString(),
      }
    );
  } catch (error) {
    console.error("Error al actualizar la worksession", error);
    throw error;
  }
}